import React, { useMemo } from 'react'
import VerticalGroup from '../../atoms/verticalgroup/VerticalGroup'
import { TeamsWithColours } from './RoundResults'
import ResultsTeamLineChart from './charts/ResultsTeamLineChart'
import { getYAxisDataV2 } from './charts/yaxis'
import YAxisIndicator from './yAxisIndicator/YAxisIndicator'
import ChartCard from './components/ChartCard'

interface Props {
  pastRound1: boolean
  teams: TeamsWithColours[]
  overallWinningMetric: ModelAPI.Reporting.DataAndPositions
}

const RoundResultsOverallWinningMetric: React.FC<Props> = ({ pastRound1, teams, overallWinningMetric }) => {
  const teamsWithoutCpu = useMemo(() => teams.filter((t) => !t.isCpuTeam), [teams])
  const { minValue, maxValue, numberOfTicks } = getYAxisDataV2({
    max: -1,
    min: -1 * teams.length,
    pastRound1,
    data: overallWinningMetric.data,
  })

  return (
    <VerticalGroup full center wide>
      <ChartCard heading='Overall Winning Metric'>
        <YAxisIndicator name='Weighted Ranking' topIndicator='First' bottomIndicator='Last' />
        <ResultsTeamLineChart data={overallWinningMetric.data} teams={teamsWithoutCpu} minYAxisvalue={minValue} maxYAxisvalue={maxValue} numberOfTicks={numberOfTicks} formatter={(val) => -1 * val} teamPositions={overallWinningMetric.teamPositions} />
      </ChartCard>
    </VerticalGroup>
  )
}

export default RoundResultsOverallWinningMetric
